import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Bell, ChevronDown, LogOut, Plus, User } from "lucide-react";
import { logoutUser } from "../auth";
import RequestPartModal from "./RequestPartModal";

const initials = (name) => (name?.trim()?.[0] || "M").toUpperCase();

export default function UserHeader({ unreadNotifications = 0 }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const [profileOpen, setProfileOpen] = useState(false);
  const [requestOpen, setRequestOpen] = useState(false);
  const profileRef = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) setProfileOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const active = (path) => pathname === path || pathname.startsWith(`${path}/`);
  const logout = async () => {
    await logoutUser();
    navigate("/", { replace: true });
  };

  return (
    <>
      <header className="agp-user-header">
        <div className="agp-user-header__inner">
          <nav className="agp-user-nav" aria-label="Customer navigation">
            <button className={active("/quotes") ? "active" : ""} onClick={() => navigate("/quotes")}>My Quotes</button>
            <button className={active("/search") ? "active" : ""} onClick={() => navigate("/search")}>Search</button>
            <button className={active("/comments") ? "active" : ""} onClick={() => navigate("/comments")}>Comments</button>
          </nav>

          <div className="agp-user-actions">
            <button className="agp-request-btn" onClick={() => setRequestOpen(true)}>
              <span className="agp-request-btn__icon"><Plus size={13} strokeWidth={3} color="black" /></span>
              Request Part
            </button>

            <button className="agp-bell" onClick={() => navigate("/notifications")} aria-label="Notifications">
              <Bell size={18} />
              {unreadNotifications > 0 && <span>{Math.min(unreadNotifications, 9)}</span>}
            </button>

            <div className="agp-profile" ref={profileRef}>
              <button className="agp-profile__button" onClick={() => setProfileOpen((v) => !v)}>
                <span className="agp-profile__avatar">{initials(user?.name)}</span>
                <span className="agp-profile__name">{user?.name || "Johan smith"}</span>
                <ChevronDown size={14} className={profileOpen ? "rotate-180" : ""} />
              </button>
              {profileOpen && (
                <div className="agp-profile__menu">
                  <button onClick={() => { setProfileOpen(false); navigate("/profile"); }}><User size={16} /> Profile</button>
                  <button className="danger" onClick={logout}><LogOut size={16} /> Logout</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <RequestPartModal
        open={requestOpen}
        onClose={() => setRequestOpen(false)}
        onSubmitted={() => navigate("/quotes")}
      />

    </>
  );
}
